import React from 'react';
import './productyoutube.css';

const YouTubeEmbed = ({ product }) => {
  const embedUrl = `https://www.youtube.com/embed/${product.videoId}`;

  return (
    <section className="youtube-embed-container">
        <div className='youtube-embed-wrapper'>
            <iframe
                src={embedUrl}
                title={`Video om ${product.namn}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
            />
        </div>
        <div className="youtube-embed-description">
            <h2 className="youtube-embed-title">Hur fungerar {product.namn}?</h2>
            <p>Tidsbesparande och enkel hantering av avfall</p>
            <ol>
                {Object.values(product.användning_manual).map((instruction, index) => (
                    <li key={index}>{instruction}</li>
                ))}
            </ol>
        </div>
    </section>
  );
};

export default YouTubeEmbed;
